<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-2">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <i
                      class="fa fa-calendar-check-o"
                      aria-hidden="true"
                      style="font-size: 40px; color: #370f70"
                    ></i>
                  </div>
                </div>
                <div class="col-md-5 remove-padding-left">
                  <div class="">
                    <h4 class="text-white font-weight mobile_text">
                      {{ $t("text.iEvents.eventReport") }}
                    </h4>
                  </div>
                  <div class="mt-3">
                    <h6 class="text-white mobile_text_para">
                      {{ $t("text.iEvents.getToKnow") }}
                    </h6>
                  </div>
                </div>
                <div class="col-md-4 remove-padding-left">
                  <div class="date_picker_m">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      color="#370F70"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="full__row_section mt-3">
        <div
          class="row top_section_row align-items-center events_date_label"
          style="border-radius: 20px"
        >
          <div class="col-md-9">
            <span class="date_info_span"
              >{{ $t("text.iEvents.logBetween") }}
              {{ $d(new Date(startDate), "short", this.$root.$i18n.locale) }}
              {{ $t("text.and.text") }}
              {{
                $d(new Date(endDate), "short", this.$root.$i18n.locale)
              }}</span
            >
            <span></span>
          </div>
          <!-- <div class="col-md-3">
            <div class="view_toggle_wrapper text-right">
              <div
                class="view_toggle_inner_container"
                @click="toggleView('calendar')"
                :class="[view === 'calendar' ? 'calendar_toggle_tab' : null]"
              >
                <i
                  class="fa fa-th"
                  aria-hidden="true"
                  style="color: white; font-size: 25px; cursor: pointer"
                  v-b-tooltip.hover
                  titl="Calendar View"
                  :style="[
                    view === 'calendar'
                      ? { color: 'white' }
                      : { color: 'lightgrey' },
                  ]"
                ></i>
              </div>
              <div
                class="view_toggle_inner_container"
                @click="toggleView('list')"
                :class="[view === 'list' ? 'list_toggle_tab' : null]"
              >
                <i
                  class="fa fa-list"
                  aria-hidden="true"
                  :style="[
                    view === 'list'
                      ? { color: 'white' }
                      : { color: 'lightgrey' },
                  ]"
                  style="font-size: 25px; cursor: pointer"
                  v-b-tooltip.hover
                  titl="List View"
                ></i>
              </div>
            </div>
          </div> -->
        </div>
      </section>
      <section class="mt-3 full__row_section" v-show="view === 'calendar'">
        <!--  :disable-views="['years', 'year']" -->
        <vue-cal
          style="height: 600px"
          class="mb-5"
          active-view="month"
          :events="events"
          events-on-month-view="short"
          :editable-events="{
            title: false,
            drag: false,
            resize: false,
            delete: false,
            create: false,
          }"
        >
        </vue-cal>
      </section>
      <section class="mt-3 full__row_section" v-show="view === 'list'">
        <TableLoader :showLoader="showLoader"></TableLoader>
        <ejs-grid
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
          v-show="!showLoader"
        >
          <e-columns>
            <e-column field="index" width="40" headerText="#"></e-column>
            <e-column
              field="date"
              width="150"
              :headerText="$t('text.iEvents.date')"
            ></e-column>
            <e-column
              field="source"
              :template="iconTemplate"
              width="350"
              :headerText="$t('text.iEvents.source')"
            ></e-column>
            <e-column
              field="startTime"
              width="100"
              :headerText="$t('text.iEvents.startTime')"
            ></e-column>
            <e-column
              field="endTime"
              width="100"
              :headerText="$t('text.iEvents.endTime')"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Events:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    VueCal,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // view: "calendar",
      view: "list",
      startDate: this.$moment().subtract(31, "days").format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(600, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().subtract(500, "days").format("D-M-YYYY"),
      dateRange: {
        start: this.$moment().subtract(7, "days").format("D-M-YYYY"),
        end: this.$moment().format("D-M-YYYY"),
      },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      backImg,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      industryBranch: null,
      industryBranchId: null,
      events: [],
      iconTemplate: function () {
        return {
          template: Vue.component("actionTemplate", {
            //  <div class="col-md-1">
            //               <span class="" v-if="data.source === 'Power Grid'"><img class="mr-2" src="https://efueling.epump.com.ng/img/042-electric_tower.svg" width="40px" /></span>
            //               <span class="" v-if="data.source === 'Generator'"><img class="mr-2" src="https://efueling.epump.com.ng/img/002-energy.4de086a6.svg" width="40px" /></span>
            //   </div>
            template: ` 
                     <div class="row align-items-center" style="margin: 0 auto">
                       
                        <div class="col-md-4">
                            <span class="ml-4"> {{data.event}}</span>
                        </div>
                    </div>
                    `,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {},
          }),
        };
      },
    };
  },
  created() {
    // this.dateRange.start  = this.pluginStartDate
    // this.dateRange.end  = this.pluginEndDate
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getEvents();
        this.parseCalendarEvents();
      }
    },
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
        function searchFun(event) {
          var grid =
            document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var value = event.target.value;
          grid.search(value);
        }
        this.getEvents();
        this.parseCalendarEvents();
      }
    },
  },
  mounted() {},
  methods: {
    toggleView(v) {
      this.view = v;
    },

    getEvents() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerChangeEvent/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          // console.log(res.data)
          this.showLoader = false;
          let index = 0;
          // const newDat = res.data.filter(el => el.source !== "");
          // const newData =  res.data.filter(el => el.source !== 'Nill');
          // newData.forEach((el,index) => {
          //     el.index = index + 1;
          //     el.date = this.$moment(el.startDate ).format("MMMM D, YYYY")
          //     el.startTime = this.$moment(el.startDate ).format("h:mm A");
          //     el.endTime = this.$moment(el.endDate ).format("h:mm A");
          //     if(el.source === 'Nill') {
          //       el.event = "No power"
          //     }else {
          //       el.event = `Power Source Changed To ${el.source}`
          //     }

          // })

          // newData
          //   .sort((a, b) => {
          //     if (a.date !== b.date) {
          //       return a.date > b.date ? -1 : a.date < b.date ? 1 : 0
          //     }
          //   })
          // this.$refs.dataGrid.ej2Instances.setProperties({
          //   dataSource: newData
          // });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    parseCalendarEvents() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerChangeEvent/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          let index = 0;
          const newDat = res.data.filter((el) => el.source !== "");
          const newData = newDat.filter((el) => el.source !== "Nill");
          const events = [];
          newData.forEach((el, i) => {
            el.index = i + 1;
            el.date = this.$moment(el.startDate).format("MMMM D, YYYY");
            el.startTime = this.$moment(el.startDate).format("h:mm A");
            el.endTime = this.$moment(el.endDate).format("h:mm A");
            if (el.source === "Nill") {
              el.event = "No power";
            } else {
              el.event = `Power Source Changed To ${el.source}`;
            }
            let title = "";
            if (el.source === "Nill") {
              title = "No power";
            } else {
              title = `Power Source Changed To ${el.source}`;
            }
            const startDateTime =
              this.$moment(el.startDate).format("YYYY-MMMM-DD") +
              " " +
              this.$moment(el.startDate).format("h:mm");
            const endDateTime =
              this.$moment(el.endDate).format("YYYY-MMMM-DD") +
              " " +
              this.$moment(el.endDate).format("h:mm");
            events.push({
              start: startDateTime,
              end: endDateTime,
              title: `<i class="fa fa-calendar-check-o" aria-hidden="true"></i><span style="font-size: 12px"> ${title}</span> `,
              class: "active_date_pane",
            });
          });
          //console.log(newData)
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: newData,
          });
          this.events = events;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
  },
};
</script>
